import React from 'react'
import FlatButton from 'material-ui/FlatButton'
import Photo from 'material-ui/svg-icons/image/photo'
import FixedImg from './FixedImg'

const styles = {
  error: {
    fontSize: '12px',
    lineHeight: '12px',
    color: 'rgb(244, 67, 54)',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  },
  // TODO: Maybe move in common styles..
  imgBtn: {
    border: '0.5px solid',
    marginTop: 20,
  },
}

const ImageField = field => {
  // TODO: Maybe move in utils
  const handleChange = e => {
    const file = e.target.files[0]
    const reader = new FileReader()

    reader.addEventListener('load', e => {
      field.input.onChange(e.target.result)
    })
    reader.readAsDataURL(file)
  }

  return (
    <div>
      <FlatButton
        label="Carica Immagine"
        labelPosition="before"
        containerElement="label"
        style={styles.imgBtn}
        icon={<Photo />}
        primary={true}>
        <input
          type="file"
          onChange={handleChange}
          style={{ display: 'none' }}
        />
      </FlatButton>
      {field.meta.touched &&
        field.meta.error &&
        <div style={styles.error}>{field.meta.error}</div>}

      {field.input.value && <FixedImg src={field.input.value} height={200} />}
    </div>
  )
}

export default ImageField



// WEBPACK FOOTER //
// ./src/common/ImageField.js